import React, { useState, useEffect } from "react";
import DashboardNav from "../DashboardNavbar/DashboardNav";
import icon_people from "../../assets/img/icon_people.png";
import dayjs from "dayjs";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
  TablePagination,
  Skeleton,
} from "@mui/material";
import MoreDetailsModal from "../../components/modal/MoreDetailsModal";
import { useTheme } from "@mui/material/styles";
import { getAllOrders } from "../../api/Api";
const OrderDashboard = () => {
  const theme = useTheme();
  const [apiOrders, setApiOrders] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [todaysOrders, setTodaysOrders] = useState(0);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const [searchOrder, setSearchOrder] = useState("");
  const [deliveryStatus, setDeliveryStatus] = useState("");
  const [username, setUsername] = useState("");
  const [deliveredToday, setDeliveredToday] = useState(0);
  const [filterDate, setFilterDate] = useState(dayjs().format("YYYY-MM-DD"));

  //pagination states
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [open, setOpen] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  const handleOpen = (transaction) => {
    setSelectedTransaction(transaction);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedTransaction(null);
  };
  useEffect(() => {
    setLoading(true);
    const fetchOrders = async () => {
      try {
        const response = await getAllOrders();
        const orders = response.data.orders;
        setApiOrders(orders);

        // Calculate counts
        const totalOrders = orders.length;
        setTotalOrders(totalOrders);
        const todaysDate = dayjs().format("YYYY-MM-DD");
        const todaysOrders = orders.filter(
          (order) => dayjs(order.placed_at).format("YYYY-MM-DD") === todaysDate
        );

        const deliveredToday = todaysOrders.filter(
          (order) => order.order_status === "Delivered"
        ).length;
        setTodaysOrders(todaysOrders.length);
        setDeliveredToday(deliveredToday);
      } catch (error) {
        console.error("Error fetching orders from API:", error);
      }
      setLoading(false);
    };
    fetchOrders();
  }, []);

  useEffect(() => {
    setLoading(true);
    const filtered = apiOrders.filter((transaction) => {
      const orderDate = transaction.placed_at
        ? dayjs(transaction.placed_at).format("YYYY-MM-DD")
        : null;

      return (
        (searchOrder === "" ||
          transaction._id.slice(-4).includes(searchOrder)) &&
        (deliveryStatus === "" ||
          transaction.order_status
            .toLowerCase()
            .includes(deliveryStatus.toLowerCase())) &&
        (username === "" ||
          transaction.user_name
            .toLowerCase()
            .includes(username.toLowerCase())) &&
        (filterDate === "" || orderDate === filterDate)
      );
    });

    setFilteredOrders(filtered);
    setLoading(false);
  }, [apiOrders, searchOrder, deliveryStatus, username, filterDate]);

  const handleSearchOrderChange = (e) => setSearchOrder(e.target.value);
  const handleDeliveryStatusChange = (e) => setDeliveryStatus(e.target.value);
  const handleUsernameChange = (e) => setUsername(e.target.value);
  const handleFilterDateChange = (e) => setFilterDate(e.target.value);

  const handleChangePage = (_, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <Box sx={{ height: "100vh" }}>
      {/* Navbar */}
      <Box sx={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000 }}>
        <DashboardNav />
      </Box>

      {/* Main content */}
      <Box
        sx={{
          position: "absolute",
          top: "180px",
          left: 0,
          right: 0,
          px: 1,
          width: "90vw",
          margin: "auto",
          color: "#888585",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontSize: "32px",
            lineHeight: "34.85px",
            fontWeight: "500",
            fontFamily: theme.typography.fontFamily,
          }}
          gutterBottom
        >
          Manage Order
        </Typography>

        {/* Transaction Cards */}
        <Grid container spacing={1}>
          {/* Card 1 */}
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                backgroundColor: "#297643",
                borderRadius: "10px",
                color: "#F5F5F5",
                width: "80%",
                padding: "20px",
                boxShadow: "0px 4px 4px 0px #9AEFB6",
              }}
            >
              <CardContent>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "24px", fontWeight: "500" }}
                      gutterBottom
                    >
                      Total no of Orders
                    </Typography>
                    <Box display="flex" alignItems="center" gap={"2rem"}>
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: "500",
                          marginRight: 1,
                          marginBottom: "5px",
                          fontSize: "36px",
                        }}
                      >
                        {totalOrders}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: "#36AB5D",
                      borderRadius: "50%",
                      width: "60px",
                      height: "60px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={icon_people}
                      alt=""
                      style={{
                        width: "70%",
                        height: "70%",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          {/* Card 2 */}
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                backgroundColor: "#A99B24",
                borderRadius: "10px",
                color: "#F5F5F5",
                width: "80%", // Ensure consistent width
                padding: "20px",
                boxShadow: "0px 4px 4px 0px #B0A333",
              }}
            >
              <CardContent>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "24px", fontWeight: "500" }}
                      gutterBottom
                    >
                      Today's Order
                    </Typography>
                    <Box display="flex" alignItems="center" gap={"2rem"}>
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: "500",
                          marginRight: 1,
                          marginBottom: "5px",
                          fontSize: "36px",
                        }}
                      >
                        {todaysOrders}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: "#625C27",
                      borderRadius: "50%",
                      width: "60px",
                      height: "60px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={icon_people}
                      alt=""
                      style={{
                        width: "70%",
                        height: "70%",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          {/* card 3 */}
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                backgroundColor: "#947FF6",
                borderRadius: "10px",
                color: "#F5F5F5",
                width: "80%", // Ensure consistent width
                padding: "20px",
                boxShadow: "0px 4px 4px 0px #3D2C8B",
              }}
            >
              <CardContent>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "24px", fontWeight: "500" }}
                      gutterBottom
                    >
                      Today's Delivered Order
                    </Typography>
                    <Box display="flex" alignItems="center" gap={"2rem"}>
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: "500",
                          marginRight: 1,
                          marginBottom: "5px",
                          fontSize: "36px",
                        }}
                      >
                        {deliveredToday}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: "#3D2C8B",
                      borderRadius: "50%",
                      width: "60px",
                      height: "60px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={icon_people}
                      alt=""
                      style={{
                        width: "70%",
                        height: "70%",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        {/* Orders Details */}
        <Box sx={{ mt: 4, color: "#888585" }}>
          <Grid
            item
            xs={12}
            md={12}
            sx={{ textAlign: "right", marginRight: "5vw" }}
          >
            {/* <Button
              variant="contained"
              sx={{
                background: "#208EE1",
                padding: "15px",
                width: "13%",
                margin: "auto",
              }}
            >
              View Details
            </Button> */}
          </Grid>
          <Typography
            variant="h4"
            sx={{
              fontSize: "32px",
              lineHeight: "34.85px",
              fontWeight: "500",
              fontFamily: theme.typography.fontFamily,
            }}
            gutterBottom
          >
            Order Details
          </Typography>
          {/* Filter Fields */}
          <Grid
            container
            spacing={1}
            sx={{ mb: 2, alignItems: "center", gap: "0.1rem" }}
          >
            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                label="Search Order"
                variant="outlined"
                value={searchOrder}
                onChange={handleSearchOrderChange}
                sx={{ maxWidth: "90%" }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                label="Search Delivery Status"
                variant="outlined"
                value={deliveryStatus}
                onChange={handleDeliveryStatusChange}
                sx={{ maxWidth: "90%" }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                label="Search by Username"
                variant="outlined"
                value={username}
                onChange={handleUsernameChange}
                sx={{ maxWidth: "90%" }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Filter by Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                value={filterDate}
                onChange={handleFilterDateChange}
                sx={{ maxWidth: "90%" }}
              />
            </Grid>
          </Grid>
          {/* Orders Table */}
          <TableContainer component={Paper} sx={{ mt: 4 }}>
            {loading ? (
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: theme.palette.primary.light }}>
                    {[
                      "Sl No",
                      "Order Id",
                      "User Name",
                      "Item Name",
                      "Order Placed On",
                      "Quantity",
                      "Payment Status",
                      "Delivery Status",
                      "Actions",
                    ].map((header, index) => (
                      <TableCell
                        key={index}
                        sx={{ color: "#fff", fontSize: "16px" }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      Loading...
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            ) : (
              <>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor:theme.palette.primary.light }}>
                      <TableCell sx={{ color: "#fff", fontSize: "16px" }}>
                        Sl No
                      </TableCell>
                      <TableCell sx={{ color: "#fff", fontSize: "16px" }}>
                        Order Id
                      </TableCell>
                      <TableCell sx={{ color: "#fff", fontSize: "16px" }}>
                        User Name
                      </TableCell>
                      <TableCell sx={{ color: "#fff", fontSize: "16px" }}>
                        Item Name
                      </TableCell>
                      <TableCell sx={{ color: "#fff", fontSize: "16px" }}>
                        Order Placed On
                      </TableCell>
                      <TableCell sx={{ color: "#fff", fontSize: "16px" }}>
                        Quantity
                      </TableCell>
                      <TableCell sx={{ color: "#fff", fontSize: "16px" }}>
                        Payment Status
                      </TableCell>
                      <TableCell sx={{ color: "#fff", fontSize: "16px" }}>
                        Delivery Status
                      </TableCell>
                      <TableCell sx={{ color: "#fff", fontSize: "16px" }}>
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredOrders.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          No data available
                        </TableCell>
                      </TableRow>
                    ) : (
                      filteredOrders
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .reverse()
                        .map((row, index) => {
                          console.log("Row Data:", row); // Log the row data
                          return (
                            <TableRow key={row._id}>
                              <TableCell>
                                {page * rowsPerPage + index + 1}
                              </TableCell>
                              <TableCell>{row._id.slice(-4)}</TableCell>
                              <TableCell>{row.user_name}</TableCell>
                              <TableCell>{row.product_name}</TableCell>
                              <TableCell>
                                {row.placed_at
                                  ? dayjs(row.placed_at).format(
                                      "YYYY-MM-DD hh:mm A"
                                    )
                                  : ""}
                              </TableCell>
                              <TableCell>{row.quantity}</TableCell>
                              <TableCell
                                sx={{
                                  color:
                                    row.payment_status === "Success"
                                      ? "#297643"
                                      : "#EA4245",
                                }}
                              >
                                {row.payment_status}
                              </TableCell>
                              <TableCell
                                sx={{
                                  color:
                                    row.order_status === "Pending"
                                      ? "red"
                                      : row.order_status === "Delivered"
                                      ? "#297643"
                                      : row.order_status === "Dispatched"
                                      ? "#208EE1"
                                      : row.order_status === "Failed"
                                      ? "#EA4245"
                                      : "inherit",
                                }}
                              >
                                {row.order_status}
                              </TableCell>
                              <TableCell>
                                <Button
                                  variant="outlined"
                                  sx={{
                                    color: "#ffffff",
                                    backgroundColor: "#FF893A",
                                    "&:hover": { backgroundColor: "#43A047" },
                                  }}
                                  onClick={() => handleOpen(row)}
                                >
                                  More Details
                                </Button>
                              </TableCell>
                            </TableRow>
                          );
                        })
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  component="div"
                  count={filteredOrders.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </>
            )}
          </TableContainer>
          <MoreDetailsModal
            open={open}
            onClose={handleClose} // Ensure this matches the prop name used in MoreDetailsModal
            transaction={selectedTransaction}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default OrderDashboard;
